import { LABELS } from '@/constants/common/message.constants'

import { type PartnerEntity, type CustomerEntity } from '../../aspida/@types'

/**
 * サイト
 */
export type SightMonthOffset = NonNullable<
  PartnerEntity['sightMonthOffset'] | CustomerEntity['sightMonthOffset']
>

export const SIGHT_MONTH_OFFSET = {
  /** 翌月 */
  MONTH_1: 'MONTH_1',
  /** 翌々月 */
  MONTH_2: 'MONTH_2',
  /** 当月 */
  MONTH_0: 'MONTH_0'
} as const satisfies Record<SightMonthOffset, SightMonthOffset>

export const SIGHT_MONTH_OFFSET_LABEL = {
  [SIGHT_MONTH_OFFSET.MONTH_1]: LABELS.SIGHT_MONTH_1,
  [SIGHT_MONTH_OFFSET.MONTH_2]: LABELS.SIGHT_MONTH_2,
  [SIGHT_MONTH_OFFSET.MONTH_0]: LABELS.SIGHT_MONTH_0
} as const satisfies Record<SightMonthOffset, string>

export function getSightMonthOffsetLabel(sight: SightMonthOffset): string {
  return SIGHT_MONTH_OFFSET_LABEL[sight]
}
